import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const analyticsDeskAnalysisRoutes = [
	{
		key: "analytics-desk-analysis",
		exact: true,    
		path: `${APP_PREFIX_PATH}/analytics/desk-analysis`,
		component: React.lazy(() => import("views/analytics-views/dashboards/sub-dashboards/internal/desk-analysis/pages/DeskAnalysis")),
	},
];
